import { Fragment, useMemo, useState } from 'react';
import { Button } from '@schibsted-svp/react-ui';
import { Link } from 'react-router-dom';

import { Table } from '../Table/Table';

import { EditorRow } from './EditorRow/EditorRow';

import type { EditorResponse } from '../../types';

type Props = {
  editors: EditorResponse[];
  loading?: boolean;
};

function EditorsTable({ editors, loading }: Props) {
  const [filter, setFilter] = useState('');

  const filtered = useMemo(
    () =>
      editors.filter((editor) =>
        editor.name.toLowerCase().includes(filter.toLowerCase())
      ),
    [editors, filter]
  );

  return (
    <Fragment>
      <Table
        items={[...filtered]}
        renderHeader={() => (
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Updated</th>
          </tr>
        )}
        renderRow={(editor) => <EditorRow editor={editor} key={editor.id} />}
        renderActions={() => (
          <Link to="/editors/new">
            <Button type="button">Create a new editor</Button>
          </Link>
        )}
        onFilterChange={setFilter}
        loading={loading}
      />
    </Fragment>
  );
}

export { EditorsTable };
